import { detectTld, fmtMsg, GLGlobal, PrimaryLanguageLocale, TldValues } from "vue-glcommonui";
import { Layout } from "@/locales/localeid";
import { computed, defineComponent, ref } from "vue";

export default defineComponent({
  setup() {
    const openPrivacyPolicy = () => {
      const loginInfo = typeof GLGlobal.loginInfo === "function" ? GLGlobal.loginInfo() : null;
      const profile = loginInfo && loginInfo.profile;
      const rcc = profile && typeof profile.rcc === "string" ? profile.rcc.toUpperCase() : "";
      const countryCode = localStorage.getItem("gl-common.countrycode") || rcc;

      if (countryCode === "KR") {
        window.open(`${GLGlobal.authorityUrl()}/Copyright/privacy-policy?region=${countryCode}&language=${PrimaryLanguageLocale.Korean}`);
        return;
      }

      window.open(`${GLGlobal.authorityUrl()}/Copyright/privacy-policy`);
    };
    const copyRightYear = ref("2026");
    const version = ref("V12.4");
    const isRussia = detectTld(window.location.hostname) === TldValues.Russia;
    const privacyText = computed(() => fmtMsg(Layout.PrivacyPolicy));
    const copyRightText = computed(() =>
      isRussia
        ? `Copyright © ${copyRightYear.value} GrapeSEED Media Ltd. All rights reserved`
        : `Copyright © ${copyRightYear.value} GrapeSEED International Pte. Ltd. All rights reserved`
    );
    return {
      openPrivacyPolicy,
      privacyText,
      copyRightText,
      version,
    };
  },
});
